export default __webpack_public_path__ + "static/media/icon-small-calendar.e92a2457.svg";